import { Spin } from "antd";
import type { ReactNode } from "react";

export interface LoaderProps {
  height?: string;
  className?: string;
  children?: ReactNode;
}

const Loader = ({
  height = "h-screen",
  className = "",
  children,
}: LoaderProps) => (
  <div className={`${height} flex items-center justify-center ${className}`}>
    {children ?? <Spin size="large" />}
  </div>
);

export default Loader;
